/**
 * Stable class names for BEM / page-scoped CSS hooks (DevTools, future *.module.css).
 * Convention: pages use `*-page`, UI primitives `ui-*`, feature components `cmp-*`.
 */

/** PascalCase or camelCase → kebab-case */
export function toKebabCase(name: string): string {
  return name
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase()
}

/** Page root: `compliance-page`, `home-page` */
export function pageScope(slug: string): string {
  const s = slug.replace(/-page$/, '').trim()
  return `${s}-page`
}

/** Feature component root: `cmp-active-scans-table` */
export function componentScope(componentName: string): string {
  const base = componentName.replace(/\.tsx?$/, '').trim()
  return `cmp-${toKebabCase(base)}`
}

/** UI kit (buttons, dropdowns): `ui-button` */
export function uiScope(name: string): string {
  return `ui-${toKebabCase(name)}`
}
